import Vue from "vue";
import Router from "vue-router";
import RetailInstanceCreate from "@/views/retailInstance/create/RetailInstanceCreate";
import RetailInstanceList from "@/views/retailInstance/list/RetailInstanceList";
import RetailInstanceDetail from "@/views/retailInstance/detail/RetailInstanceDetail";
import List from "@/views/basicInstance/list/List";
import Detail from "@/views/basicInstance/detail/Detail";
import CreateCase from "@/views/basicInstance/create/CreateCase";
import PrivateNetInstanceList from "@/views/privateNetInstance/list/PrivateNetInstanceList";
import InstanceDetail from "@/views/privateNetInstance/detail/InstanceDetail";
import ReinstallSystem from "@/components/privateNetInstance/reinstallSystem/reinstallSystem.vue";
import InstanceCreate from "@/views/privateNetInstance/create/InstanceCreate";
import GameInstanceList from "@/views/gameInstance/list/List";
import GameInstanceCreate from "@/views/gameInstance/create/Create";
import GameGuide from "@/views/gameInstance/guide/Index";
import MirrorList from "@/views/mirror/list/List";
import MirrorDetail from "@/views/mirror/detail/Detail";
import PrivateNetworkList from "@/views/privateNetwork/list/PrivateNetworkList";
import PrivateDetail from "@/views/privateNetwork/detail/Detail";
import PerformanceMonitor from "@/components/common/PerformanceMonitor";
import SubnetList from "@/views/subnet/list/List";
import SubnetDetail from "@/views/subnet/detail/Detail";
import EipList from "@/views/eip/list/List";
import EipDetail from "@/views/eip/detail/Detail";
import EipCreate from "@/views/eip/create/Create";
import SbwList from "@/views/sbw/list/List";
import SbwDetail from "@/views/sbw/detail/Detail";
import SbwCreate from "@/views/sbw/create/Create";
import NatCreate from "@/views/nat/create/Create";
import NatList from "@/views/nat/list/List";
import NatDetail from "@/views/nat/detail/Detail";
import PeeringList from "@/views/peering/list/List";
import PeeringDetail from "@/views/peering/detail/Detail";
import PeeringCreate from "@/views/peering/create/Create";
import SlbList from "@/views/slb/list/List";
import SlbDetail from "@/views/slb/detail/Detail";
import ListenerDetail from "@/views/slb/detail/listener/detail/Detail";
import ListenerEdit from "@/views/slb/detail/listener/edit/Edit";
import RibList from "@/views/rib/RibList";
import RibDetail from "@/views/rib/RibDetail";
import ServerDetail from "@/views/slb/detail/serverGroup/detail/ServerDetail";
import SSHList from "@/views/ssh/list/List";
import SSHDetail from "@/views/ssh/detail/Detail";
import Ipv6List from "@/views/ipv6/list/List";
import Ipv6Detail from "@/views/ipv6/detail/Detail";
import Ipv6Create from "@/views/ipv6/create/Create";
import CertList from "@/views/slb/cert/list/List";
import CertDetail from "@/views/slb/cert/detail/Detail";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            // 不匹配的路由，跳回首页（当前没有404页）
            path: "*",
            redirect: "/",
            meta: {}
        },
        {
            path: "/",
            name: "Default",
            component: List
        },
        /** **************零售中台实例相关 START*************** */
        {
            name: "RetailInstanceList",
            path: "/instance/retail/list",
            component: RetailInstanceList
        },
        {
            name: "RetailInstanceDetail",
            path: "/instance/retail/detail",
            component: RetailInstanceDetail,
            children: [
                {
                    path: "performance",
                    component: PerformanceMonitor
                }
            ]
        },
        {
            name: "RetailInstanceCreate",
            path: "/instance/retail/create",
            component: RetailInstanceCreate
        },
        /** **************零售中台实例相关 END*************** */
        /** **************基础实例相关 START*************** */
        {
            path: "/instance/basic/list",
            name: "List",
            component: List
        },
        {
            path: "/instance/basic/detail/:id/:region/:az",
            name: "Detail",
            component: Detail,
            children: [
                {
                    path: "performance",
                    component: PerformanceMonitor
                }
            ]
        },
        {
            path: "/instance/basic/create",
            name: "CreateCase",
            component: CreateCase
        },
        /** **************基础实例相关 END*************** */

        /** **************VPC实例相关 START*************** */
        {
            name: "PrivateNetInstanceList",
            path: "/instance/vpc/list",
            component: PrivateNetInstanceList
        },
        {
            name: "InstanceDetail",
            path: "/instance/vpc/detail",
            component: InstanceDetail,
            children: [
                {
                    path: "performance",
                    component: PerformanceMonitor
                }
            ]
        },
        {
            name: "ReinstallSystem",
            path: "/instance/vpc/reinstall",
            component: ReinstallSystem
        },
        {
            name: "CreatePrivateInstance",
            path: "/instance/vpc/create",
            component: InstanceCreate
        },
        /** **************VPC实例相关 END*************** */

        /** **************游戏实例相关 START*************** */
        {
            name: "GameInstanceList",
            path: "/instance/game/list",
            component: GameInstanceList
        },

        {
            name: "GameInstanceCreate",
            path: "/instance/game/create",
            component: GameInstanceCreate
        },
        {
            name: "GameGuide",
            path: "/instance/game/guide",
            component: GameGuide
        },
        /** **************游戏实例相关 END*************** */

        /** **************镜像相关 START*************** */
        {
            name: "MirrorList",
            path: "/image/list",
            component: MirrorList
        },
        {
            name: "MirrorDetail",
            path: "/image/detail",
            component: MirrorDetail
        },
        /** **************镜像相关 END*************** */

        /** **************私有网络相关 START*************** */
        {
            name: "PrivateNetworkList",
            path: "/vpc/list",
            component: PrivateNetworkList
        },
        {
            name: "PrivateDetail",
            path: "/vpc/detail",
            component: PrivateDetail
        },
        /** **************私有网络相关 END*************** */

        /** **************子网相关 START*************** */
        // 子网列表
        {
            name: "SubnetList",
            path: "/subnet/list",
            component: SubnetList
        },
        // 子网详情
        {
            name: "SubnetDetail",
            path: "/subnet/detail",
            component: SubnetDetail
        },
        /** **************子网相关 END*************** */

        /** **************EIP相关 START*************** */
        {
            name: "EipList",
            path: "/eip/list",
            component: EipList
        },
        {
            name: "EipDetail",
            path: "/eip/detail/:id/:region",
            component: EipDetail
        },
        {
            name: "EipCreate",
            path: "/eip/create",
            component: EipCreate
        },
        /** **************EIP相关 END*************** */

        /** **************共享带宽 START*************** */
        {
            name: "SbwList",
            path: "/sbw/list",
            component: SbwList
        },
        {
            name: "SbwDetail",
            path: "/sbw/detail/:id/:region",
            component: SbwDetail
        },
        {
            name: "SbwCreate",
            path: "/sbw/create",
            component: SbwCreate
        },
        /** **************共享带宽相关 END*************** */

        /** **************NAT网关相关 START*************** */
        {
            name: "NatCreate",
            path: "/nat/create",
            component: NatCreate
        },
        {
            name: "NatList",
            path: "/nat/list",
            component: NatList
        },
        {
            name: "NatDetail",
            path: "/nat/detail",
            component: NatDetail
        },
        /** **************NAT网关相关 END*************** */
        /** **************对等连接相关 START*************** */
        {
            name: "PeeringCreate",
            path: "/peering/create",
            component: PeeringCreate
        },
        {
            name: "PeeringList",
            path: "/peering/list",
            component: PeeringList
        },
        {
            name: "PeeringDetail",
            path: "/peering/detail/:id/:region",
            component: PeeringDetail
        },
        /** **************对等连接相关 END*************** */
        /** **************SLB相关 START*************** */
        {
            name: "SlbList",
            path: "/lb/list",
            component: SlbList
        },
        {
            name: "SlbCreate",
            path: "/lb/create",
            // component: SlbCreate,
            component: () =>
                import(
                    /* webpackChunkName: "SlbCreate" */ "@/views/slb/create/SlbCreate"
                )
        },
        {
            name: "SlbDetail",
            path: "/lb/detail",
            component: SlbDetail
        },
        {
            name: "ListenerDetail",
            path: "/lb/listener/detail",
            component: ListenerDetail
        },
        {
            name: "ListenerEdit",
            path: "/lb/listener/edit",
            component: ListenerEdit
        },
        {
            name: "ServerDetail",
            path: "/lb/server/detail",
            component: ServerDetail
        },
        {
            name: "CertList",
            path: "/lb/cert/list",
            component: CertList
        },
        {
            name: "CertDetail",
            path: "/lb/cert/detail",
            component: CertDetail
        },
        /** **************SLB END*************** */
        /** **************路由表 START*************** */
        {
            name: "RibList",
            path: "/routeTable/list",
            component: RibList
        },
        {
            name: "RibDetail",
            path: "/routeTable/detail",
            component: RibDetail
        },
        /** **************路由表 END*************** */
        /** **************SSH START*************** */
        {
            name: "SSHList",
            path: "/ssh/list",
            component: SSHList
        },
        {
            name: "SSHDetail",
            path: "/ssh/detail",
            component: SSHDetail
        },
        /** **************SSH END*************** */
        /** **************Ipv6 START*************** */
        {
            name: "Ipv6List",
            path: "/ipv6/list",
            component: Ipv6List
        },
        {
            name: "Ipv6Detail",
            path: "/ipv6/detail",
            component: Ipv6Detail
        },
        {
            name: "Ipv6Create",
            path: "/ipv6/create",
            component: Ipv6Create
        }
        /** **************Ipv6 END*************** */
    ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js